<template>
    <span class="help-tooltip">
        <span class="iconfont icon-menu-help help-tooltip-icon" />
        <span
            class="help-tooltip-tip"
            v-click="clickOption"
            v-html="tip"
            :style="{ width: `${width}px` }"
        ></span>
    </span>
</template>
<script>
export default {
    inject: ['colorMap'],
    props: {
        show: { type: Boolean, default: false },
        tip: { type: String, default: '' },
        width: { type: Number, default: 300 },
        clickOption: { type: Object, default: () => ({}) }
    }
};
</script>
<style lang="scss">
.help-tooltip {
    --icon-size: 16px;
    position: relative;
    margin: 0;
    padding: 0;
    font-size: 0;
    &:hover {
        .help-tooltip-tip,
        .help-tooltip-tip::after {
            display: block;
        }
    }
    .help-tooltip-icon {
        position: relative;
        margin-left: 4px;
        z-index: 1;
        cursor: pointer;
        text-align: center;
        font-size: var(--icon-size);
    }
    .help-tooltip-tip {
        display: none;
        position: absolute;
        top: calc(100% + 8px);
        right: -60px;
        z-index: 10;
        font-family: var(--font-normal);
        color: #fff;
        background-color: #191919;
        padding: 10px 20px;
        font-size: 12px;
        line-height: 1.5;
        font-weight: 500;
        box-shadow: 0 2px 5px 0 rgba(0, 10, 30, 0.1);

        &::after {
            content: '\e79b';
            font-family: 'iconfont';
            position: absolute;
            width: 10px;
            height: 10px;
            font-size: var(--icon-size);
            top: calc(var(--icon-size) * -1);
            right: calc(var(--icon-size) + 50px); // 12: 56 14: 57, 16:58
            color: #191919;
            z-index: 10;
        }
    }
    a {
        color: var(--color-link);
        &:hover {
            text-decoration: underline;
        }
    }
}
</style>
